import {Component, OnInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfirmedValidator } from 'src/app/helpers/confirmed.validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DialogService } from 'src/app/services/dialog.service';
import { InjectDialogComponent } from '../inject-dialog/inject-dialog.component';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

    resetForm: UntypedFormGroup;
    internalServerError: boolean = false;
    showProgressBar: boolean = false;

    constructor(private dialogService: DialogService,
        private formBuilder: UntypedFormBuilder,
        private authService: AuthenticationService) {
        this.resetForm = this.formBuilder.group({
            'email': ['', [Validators.required, Validators.email]],
            'password': ['', [Validators.required]],
            'confirmPassword': ['', [Validators.required]]
        }, {
            validator: ConfirmedValidator("password", "confirmPassword")
        });
    }

    ngOnInit(): void {
    }

    revalidate() {
        this.resetForm.updateValueAndValidity();
    }

    sendMail(): void {
        if (this.resetForm.valid) {
            this.showProgressBar = true;
            this.authService.sendResetPasswordMail(this.resetForm.value).then(
                () => {
                    this.showProgressBar = false;
                    this.dialogService.openDialog(InjectDialogComponent, {
                        title: 'Промена на лозинка',
                        content: 'Испратена Ви е електронска пошта за промена на лозинката на Вашиот профил на електронската адреса. Во случај да не добивте електронска пошта, проверете во Вашата папка за спам.'
                    });
                }
            ).catch(err => {
                this.showProgressBar = false;
                this.internalServerError = true;
                console.error(err);
            });
        }
    }
}
